export const styles = {
    inputLabel: { mb: 1, fontSize: 14, fontWeight: 500, alignContent: 'center', display: 'flex' },
    labelIcon: { height: 20, width: 20 },
};